import * as React from 'react'
import { Button } from '../../atoms/button/button'
import { Context } from '../../../context/app-context'
import { Ranking } from '../ranking/ranking'
import { Instructions } from './how-to-win-info'
import './how-to-win.scss'

export const HowToWin = () => {
  const { hasParticipation } = React.useContext(Context)
  const redirectionForm = hasParticipation ? '#registrar-claves' : '#registrate'

  return (
    <section className="f-how-win" id="como-ganar">
      <div className="f-how-win__instructions">
        <h3 className="f-how-win__instructions__secondary-title">
          Recuerda que entre más claves ingreses, más posibilidades tendrás de
          ganar.
        </h3>
        <h2 className="f-how-win__instructions__title">
          ¡Sigue las instrucciones!
        </h2>

        <ul className="f-how-win__instructions__list">
          {Instructions.map((instruction, index) => {
            return (
              <li className="f-how-win__instructions__list__item" key={index}>
                <img
                  src={instruction.image || ''}
                  alt="icon 1"
                  className="f-how-win__instructions__list__item__icon"
                />
                <div className="f-how-win__instructions__list__item__description">
                  {instruction.description}
                </div>
              </li>
            )
          })}
        </ul>
        <div
          onClick={() => {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              event: 'Interacciones - Registro Claves',
              category: 'cole challenge',
              action: 'click',
              label: 'registra tus claves',
            })
          }}
        >
          <Button
            type="link"
            href={redirectionForm}
            text="REGISTRA TUS CLAVES"
            color="blue"
            className="f-how-win__instructions__button"
          />
        </div>
      </div>

      <div className="f-how-win__instructions__ranking">
        <Ranking />
      </div>
    </section>
  )
}
